import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { atencionesResolver, consultasUserClientResolver, consultasUserVetResolver, razaResolver, tallasResolver, veterinariasResolver } from './resolvers/vets.resolvers';
import { TestbackendComponent } from './shared/components/testbackend/testbackend.component';
import { AuthGuard } from 'src/core/auth/guards/auth.guard';
import { RolClientGuard } from 'src/core/auth/guards/rolClientGuard.guard';
import { RolVetGuard } from 'src/core/auth/guards/rolVetGuard.guard';

const routes: Routes = [
  {
    path: '',
    redirectTo: 'public/home',
    pathMatch: 'full'
  },
  {
    path: 'testbackend',
    component: TestbackendComponent
  },
  {
    path: 'auth',
    resolve: {
      tallas: tallasResolver,
      razas: razaResolver
    },
    loadChildren: () => import('./auth/auth.module').then(m => m.AuthModule)
  },
  {
    path: 'public',
    resolve: {
      veterinarias: veterinariasResolver
    },
    loadChildren: () => import('./public-pages/public-pages.module').then(m => m.PublicPagesModule)
  },
  {
    path: 'client',
    resolve: {
      veterinarias: veterinariasResolver,
      consultasClient: consultasUserClientResolver,
      atenciones: atencionesResolver
    },
    canActivate: [AuthGuard, RolClientGuard],
    canActivateChild: [AuthGuard, RolClientGuard],
    loadChildren: () => import('./pages-client/pages-client.module').then(m => m.PagesClientModule)
  },
  {
    path: 'vets',
    canActivate: [AuthGuard, RolVetGuard ],
    canActivateChild: [AuthGuard, RolVetGuard ],
    resolve: {
      consultasVet: consultasUserVetResolver,
      tallas: tallasResolver,
      razas: razaResolver,
      atenciones: atencionesResolver
    },
    loadChildren: () => import('./pages-admin/pages-admin.module').then(m => m.PagesAdminModule)
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
